module.exports = __webpack_public_path__ + "static/edit_content_737x507-79b1efe0001014a0c3e0c11d6bcbbe60.png";